module.exports = __webpack_public_path__ + "static/img/title.2cbe424.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/feature/title.png
// module id = 8mP3
// module chunks = 7